/* eslint-disable no-console */
const AuthModule = {
  namespaced: true,
  state: {
    user: undefined,
    token: undefined,
  },
  mutations: {
    setUser(state, newUser) {
      // eslint-disable-next-line no-param-reassign
      state.user = newUser;
    },
    setToken(state, newToken) {
      // eslint-disable-next-line no-param-reassign
      state.token = newToken;
    },
  },
  actions: {
    /**
     * Initialize from cache (localstorage)
     */
    init(context) {
      try {
        let user;
        if (localStorage.getItem(process.env.VUE_APP_AUTH_USER_DETAILS) !== 'undefined') {
          user = JSON.parse(localStorage.getItem(process.env.VUE_APP_AUTH_USER_DETAILS));
        }
        let token;
        if (localStorage.getItem(process.env.VUE_APP_AUTH_TOKEN_KEY) !== 'undefined') {
          token = JSON.parse(localStorage.getItem(process.env.VUE_APP_AUTH_TOKEN_KEY));
        }
        context.commit('setUser', user);
        context.commit('setToken', token);
      } catch (err) {
        console.error(err);
      }
    },
    /**
     * Set logged user
     */
    setUser(context, newUser) {
      if (newUser) {
        const user = {
          Id: newUser.id_usuario,
          Name: newUser.nome_usuario,
          Email: newUser.email_usuario,
          Role: newUser.desc_permissao,
          CompanyId: newUser.id_empresa,
          CompanyName: newUser.nome_empresa
        }
        context.commit('setUser', user);
      } else {
        context.commit('setUser', undefined);
      }
    },
    /**
     * Set the authentication metadata
     * @returns {token: string, expires: number}
     */
    setToken(context, newToken) {
      if (newToken) {
        const data = {
          expires: newToken.exp,
          token: newToken.token,
        };
        context.commit('setToken', data);
      } else {
        context.commit('setToken', undefined);
      }
    },
  },
  getters: {
    /**
     * Get logged user
     * @returns {token: string, expires: number}
     */
    user(state) {
      return state.user;
    },
    /**
     * Get application token
     */
    token(state) {
      return state.token;
    },
  },
};

export default AuthModule;
